import Fetch from '@cheesecakelabs/fetch'

import { BACKEND_URL } from '_config/environment'

const request = new Fetch(BACKEND_URL)

export const post = request.post.bind(request)
export const get = request.get.bind(request)
export const patch = request.patch.bind(request)
export const put = request.put.bind(request)
export const upload = request.upload.bind(request)
export const del = request.delete.bind(request)
export const generic = request.request.bind(request)

export default request



// WEBPACK FOOTER //
// ./src/services/requests.js